<template>
    <NuxtLayout name="default" mainClass="inside_main">
        <div class="terms">
        <div class="container">

            <div class="row align-items-center">
                <div class="col-12">
                    <div class="section_title">
                        <h1>
                            الشروط و الأحكام
                        </h1>
                    </div>
                </div>
            </div>

            <div class="terms-inner">

                <template v-if="termsPage">
                        <div v-html="termsPage.content"></div>
                    </template>
                    <template v-else>
                        <p>جاري تحميل الشروط والأحكام...</p>
                    </template>
                    
            </div>

        </div>
    </div>
    </NuxtLayout>
</template>

<script setup lang="ts">
import { useWebsiteStore } from '~/store/website'
import { computed } from 'vue'

// استدعاء `websiteStore`
const websiteStore = useWebsiteStore()

// استخراج الصفحة التي تحمل `label === "terms_and_conditions"`
const termsPage = computed(() => {
    return websiteStore.initializationData?.pages?.find(page => page.label === "terms_and_conditions") || null;
})


useHead({
        title: 'الشروط و الأحكام',
        meta: [
        { property: 'og:title', content: `الشروط و الأحكام | رفيو المنصة الأولى في التقييم و معرفة تجارب الآخرين و الاستفادة منها` },
        { property: 'twitter:title', content: `الشروط و الأحكام | رفيو المنصة الأولى في التقييم و معرفة تجارب الآخرين و الاستفادة منها` },       
        ]
    })
</script>